import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_MODALS_DATA } from "./ActionTypes";

export const getAllModalsData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_MODALS_DATA,
    payload,
    currentPage,
});